import { render, staticRenderFns } from "./kulturplatz_entry.vue?vue&type=template&id=8634ed9a&scoped=true"
import script from "./kulturplatz_entry.vue?vue&type=script&lang=js"
export * from "./kulturplatz_entry.vue?vue&type=script&lang=js"
import style0 from "./kulturplatz_entry.vue?vue&type=style&index=0&id=8634ed9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8634ed9a",
  null
  
)

export default component.exports